import * as React from "react"
import PowerIcon from "../../atoms/icons/PowerIcon"
import SettingsOverviewCard from "../../molecules/SettingsOverviewCard"
import ReadOnlyTextField from "../../molecules/card/ReadOnlyTextField"
import { useEdgeApi } from "../../../edge/EdgeProvider"
import { VOLTAGE_FLOAT_DECIMAL_COUNT } from "../../constants"
import { SECTION_SYSTEM_TBB_METRICS } from "../../../utils/pages"

const TbbVoltagesCard: React.FunctionComponent = () => {
  const { metrics } = useEdgeApi()

  const displayVoltage = (voltage?: number) =>
    voltage ? `${voltage.toFixed(VOLTAGE_FLOAT_DECIMAL_COUNT)} V` : undefined

  const displayCurrent = (current?: number) =>
    current ? `${current.toFixed(VOLTAGE_FLOAT_DECIMAL_COUNT)} A` : undefined

  return (
    <SettingsOverviewCard title={SECTION_SYSTEM_TBB_METRICS.name} icon={<PowerIcon />}>
      <ReadOnlyTextField placeholder="-.- V" label="48V supply" value={displayVoltage(metrics.useTbbMetricsPow48v())} />
      <ReadOnlyTextField placeholder="-.- V" label="25V supply" value={displayVoltage(metrics.useTbbMetricsPow25v())} />
      <ReadOnlyTextField placeholder="-.- V" label="12V supply" value={displayVoltage(metrics.useTbbMetricsPow12v())} />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="3.3V supply"
        value={displayVoltage(metrics.useTbbMetricsPow3v3())}
      />
      <ReadOnlyTextField
        placeholder="-.- A"
        label="Current sense"
        value={displayCurrent(metrics.useTbbMetricsCurrentSense())}
      />
      <ReadOnlyTextField
        placeholder="-.- A"
        label="BUC current"
        value={displayCurrent(metrics.useTbbMetricsBucCurrent())}
      />
      <ReadOnlyTextField
        placeholder="-.- A"
        label="LNB current"
        value={displayCurrent(metrics.useTbbMetricsLnbCurrent())}
      />
    </SettingsOverviewCard>
  )
}

export default TbbVoltagesCard
